<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight my-content" id="iframe-box">
        <!-- <button @click="getHeight">teste</button> -->
        <!-- <iframe :src="src" style="min-height: 100vh" width="100%" id="materialIframe" -->
        <!-- frameborder="0"></iframe> -->
    </div>
    <!-- 右边主体]] -->
</template>
<script>
require('./material.js');
import axios from 'Services/axios'
export default {
    data() {
        return {
            src: '',
            iframeDom: {},
            app: {},
            token: '',
        }
    },
    components: {

    },
    created() {

    },
    mounted() {
        this.app = new Material({
            container: '#iframe-box',
            style: {
                width: '100%',
                minHeight: '100vh'
            },
            url: `//ctp.qq.com/material/${this.$route.params.type}`,
            tokenUrl: '//api.tgl.qq.com/inner/material/token',
            loaded: this.init
        })
        this.app.on('getHeight', (dom, data) => {
            console.log(data)
            dom.style.height = data.height;
        })
    },
    methods: {
        async getToken() {
            const res = await axios.get(`//api.tgl.qq.com/inner/material/token`);
            if (res.status === 200 && res.data.code === 0) {
                this.token = res.data.data;
            }
        },
        init() {
            debugger
            this.getHeight()
        },
        getHeight() {
            this.app.send({
                type: 'getHeight',
                data: ''
            });
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~Assets/sass/pages/v4/manage/content.scss';
.my-content .freelance-list .operation .btn .g-btn {
    margin: 3px;
}
.list-empty {
    width: 100%;
    text-align: center;
    height: 300px;
    margin-top: 50px;
}
.js-open-reject {
    margin-left: 5px;
}
.operation {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    flex-direction: column;
}
</style>